<template>
  <div :class="[`bg`, className || ``]"><img class="rectangle" :src="src" alt="Rectangle" /></div>
</template>

<script>
export default {
  name: "Bg",
  props: ["src", "className"],
};
</script>

<style>
.bg {
  display: flex;
  height: 64px;
  left: 0;
  position: absolute;
  top: 0;
  width: 64px;
}

.rectangle {
  height: 65px;
  margin-left: -0.5px;
  margin-top: -0.5px;
  width: 65px;
}

.bg.bg-1,
.bg.bg-6 {
  justify-content: flex-end;
}

.bg.bg-1 .rectangle,
.bg.bg-6 .rectangle {
  margin-left: unset;
  margin-right: -0.5px;
}

.bg.bg-3 .rectangle,
.bg.bg-8 .rectangle {
  flex: 1;
  margin-right: -0.5px;
  width: unset;
}
</style>
